class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      // F45 — 300ms felt like the suggestions "stopped keeping up"; 200 is inside the 150–250
      // band and still coalesces fast typing into one request.
      const onInput = debounce((event) => {
        this.onChange(event);
      }, 200).bind(this);
      this.input.addEventListener('input', onInput);
      // `search` fires when WebKit's native round × clears a type=search field.
      this.input.addEventListener('search', onInput);
      /* `change` is only here for autofill / password-manager paths that commit a value without
         an `input` event. It ALSO fires on blur, which is the very gesture that dismisses the
         dropdown — running the query again there re-opened the panel ~200ms after focusout had
         closed it (with nothing left to close it again, and PredictiveSearch.isOpen stuck true,
         which the sticky header reads to suppress its scroll behaviour). So act only when the
         value is genuinely new relative to the last term searched. */
      this.input.addEventListener('change', () => {
        const q = typeof this.getQuery === 'function' ? this.getQuery() : this.input.value.trim();
        if (this.searchTerm !== undefined && q === this.searchTerm) return;
        onInput();
      });
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
